export const ANALYTICS_BETA_FEATURE = 'analytics_beta_feature'
export const ANALYTICS_BETA_FEATURE_SHIPPING_EXCEPTIONS = 'analytics_beta_feature_shipping_exceptions'
